import React, { forwardRef, useMemo } from 'react';
import { genericMemo, mergeRefs, type DistributiveOmit } from '@direct-frontend/stdlib';
import { isMobile } from '@direct-frontend/platform-code';

import { TextInput, TextInputProps } from '../TextInput';
import { PseudoInput } from '../PseudoInput/PseudoInput';

import { MaskedTextInputAdditionalProps } from './types';
import { useControlledMaskito } from './useControlledMaskito';

export type MaskedTextInputProps = DistributiveOmit<TextInputProps, 'isMaskedInput'> & MaskedTextInputAdditionalProps;

/**
 * Компонент для использования TextInput с маской
 */
export const MaskedTextInput = genericMemo(
    forwardRef<HTMLInputElement | HTMLTextAreaElement, MaskedTextInputProps>(function MaskedTextInput(props, ref) {
        const { maskConfig, onChange, value, shouldUpdateUnmaskedValue = true, ...textInputProps } = props;

        const { ref: maskitoRef, ...maskProps } = useControlledMaskito({
            maskConfig,
            onChange,
            value,
            shouldUpdateUnmaskedValue,
        });
        const setRef = useMemo(() => mergeRefs(ref, maskitoRef), [maskitoRef, ref]);

        if (isMobile() && props.isMobileTrigger) {
            return <PseudoInput {...props} onPress={props.onMobileTriggerPress} />;
        }

        return (
            <TextInput
                {...textInputProps}
                {...maskProps}
                // Внутренний проп библиотеки компонентов, не удалять
                isMaskedInput
                ref={setRef}
            />
        );
    }),
);
